module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-01@2x.4dce4c5.jpg";